import { Component, OnInit } from '@angular/core';
import { SharedMenuObserverService } from 'src/app/services/SharedMenuObserver/shared-menu-observer.service';

class Communication {
}


@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.css']
})
export class CommunicationComponent implements OnInit {


  communicationList:Communication[]=[
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {}
  ]
  constructor(private sharedMenuObserverService:SharedMenuObserverService
    ) { }

  ngOnInit(): void {
    this.sharedMenuObserverService.updateMenu("Communiqués")
  }

}
